<template>
    
</template>
<script>
export default {
    data() {
        this.$router.push({
            'name': this.$route.query.page
        })
        return {}
    }
}
</script>




// WEBPACK FOOTER //
// src/pages/ReloadCurrent.vue